var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-toolbar",
    {
      staticClass: "mb-4",
      attrs: {
        dark: "",
        color: "header"
      }
    },
    [
      _c("v-toolbar-title", [_vm._t("default")], 2),
      _c("v-spacer"),
      !_vm.hideClose
        ? _c(
            "gg-btn",
            {
              attrs: {
                icon: "",
                dark: "",
                elevation: "0",
                "aria-label": "Close"
              },
              on: {
                click: function click($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }